export default __webpack_public_path__ + "locales/az/ChangePhoneDialog.json?hash=25908389801a005afc2af57597f95df3";